import { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './style.css';

export default class LightButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    noBorder: PropTypes.bool,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    title: PropTypes.string.isRequired,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  };

  static defaultProps = {
    disabled: false,
    noBorder: false,
    onClick: undefined,
    replace: false,
    target: undefined,
    to: '',
  };

  render() {
    const {
      title,
      disabled,
      onClick,
      replace,
      target,
      to,
      noBorder,
      className,
    } = this.props;

    if (onClick) {
      return (
        <div
          className={classNames('LightButton', className, {
            LightButtonWithoutBorder: noBorder,
            LightButtonDisabled: disabled,
          })}
          onClick={disabled ? undefined : onClick}
        >
          <span>{title}</span>
        </div>
      );
    }

    return (
      <Link
        className={classNames('LightButton', className, {
          LightButtonWithoutBorder: noBorder,
          LightButtonDisabled: disabled,
        })}
        replace={replace}
        target={target}
        to={disabled ? '#' : to}
      >
        <span>{title}</span>
      </Link>
    );
  }
}
